import { Attributes, Node, mergeAttributes } from '@tiptap/core';
import { DOMOutputSpec, NodeSpec } from '@tiptap/pm/model';

export default Node.create({
  name: 'legacy-video',

  group: 'block',

  addAttributes(): Attributes | {} {
    return {
      src: {
        default: null,
        parseHTML: element => element.getAttribute('src'),
        renderHTML: ({ src }) => {
          if (!src) return;

          const allowedHosts = ['youtube.com', 'youtu.be', 'vimeo.com'];
          if (!allowedHosts.some(host => src.includes(host))) return;

          return { src };
        },
      },
      width: { default: null },
      height: { default: null },
      frameborder: { default: 0 },
      allowfullscreen: { default: true },
    };
  },

  parseHTML(): NodeSpec['parseDOM'] | undefined {
    return [{ tag: 'iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"]' }];
  },

  renderHTML({ HTMLAttributes }): DOMOutputSpec {
    return [
      'div',
      {
        'data-legacy-video': '',
        style: 'padding:56.25% 0 0 0; position:relative;',
      },
      [
        'iframe',
        mergeAttributes(HTMLAttributes, {
          style: 'position:absolute; top:0; left:0; width:100%; height:100%;',
        }),
      ],
    ];
  },
});
